import { cn } from '../../lib/utils';

interface ProgressBarProps {
  /** Progress value from 0 to 100. Clamped automatically. */
  value: number;
  /** Accessible label describing what this progress bar measures. */
  label?: string;
  /** Classes applied to the track container. Use to override height, width, background, or layout (e.g. flex-1). */
  className?: string;
  /** Classes applied to the indicator fill. Use to override color or transition. Merged with defaults via cn(). */
  indicatorClassName?: string;
}

export function ProgressBar({ value, label, className, indicatorClassName }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div
      role="progressbar"
      aria-label={label ?? `${Math.round(clamped)}% complete`}
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('h-1.5 overflow-hidden rounded-full bg-muted', className)}
    >
      <div
        className={cn(
          'h-full rounded-full bg-status-info transition-[width] duration-500',
          indicatorClassName,
        )}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
